<template>
  <table class="table is-fullwidth is-striped">
    <thead>
      <tr>
        <TableHeader
          v-for="(headerConfig, index) in headerConfigs"
          :key="`header-${index}`"
          :title="headerConfig.title"
          :property="headerConfig.sortable ? headerConfig.property : null"
          :sortedByProperty="sortedByProperty"
          :sortAscending="sortAscending"
          v-on:sort-changed="sortChanged($event)"
        />
      </tr>
    </thead>

    <tbody>
      <tr v-for="rowObject in sortedTableData" :key="rowObject.id">
        <slot name="tableRow" v-bind:rowObject="rowObject" />
      </tr>
    </tbody>
  </table>
</template>

<script>
import TableHeader from "@/components/utils/TableHeader";

export default {
  name: "Table",

  components: { TableHeader },

  props: {
    // Each object should have the type { property: string, title: string, sortable: boolean }
    headerConfigs: {
      type: Array,
      required: true
    },

    tableData: {
      type: Array,
      required: true
    },

    initialSortProperty: {
      type: String,
      default: null
    },

    initialSortAscending: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      sortedByProperty: this.initialSortProperty,
      sortAscending: this.initialSortAscending
    };
  },

  computed: {
    sortedTableData() {
      if (!this.tableData || !this.sortedByProperty) {
        return this.tableData;
      }

      var sortedTableData = [...this.tableData];

      sortedTableData.sort((firstObject, secondObject) => {
        var firstProperty = firstObject[this.sortedByProperty]
          ? firstObject[this.sortedByProperty]
          : "";
        var secondProperty = secondObject[this.sortedByProperty]
          ? secondObject[this.sortedByProperty]
          : "";

        if (firstProperty < secondProperty) {
          return this.sortAscending ? -1 : 1;
        } else if (firstProperty > secondProperty) {
          return this.sortAscending ? 1 : -1;
        } else {
          return 0;
        }
      });

      return sortedTableData;
    }
  },

  methods: {
    sortChanged(event) {
      this.sortedByProperty = event.sortedByProperty;
      this.sortAscending = event.sortAscending;
    }
  }
};
</script>

<style lang="scss" scoped>
.table {
  td {
    border-bottom: 0;

    span {
      white-space: nowrap;
    }
  }
}
</style>
